import { EventBus } from '@/event-bus'
import { Cookies } from 'quasar'
import store from '@/store/store'

export const AutoLogout = {
    timeoutId: undefined,
    warningPeriod: (1000 * 60) * 3, // n minutes

    getExpirationTimestampFromCookie () {
        if (!Cookies.has('jwt_header_payload')) return null

        try {
            const payload = JSON.parse(atob(Cookies.get('jwt_header_payload').split('.')[1]))
            if (!payload || !payload.exp) return null

            return payload.exp * 1000 // Exp claim is in number of seconds, JavaScript timestamps are number of milliseconds.
        } catch (e) {
            return null
        }
    },

    isServiceUnavailable () {
        return store.state.serviceUnavailable
    },

    onInvalidSession () {
        if (this.timeoutId) this.timeoutId = clearTimeout(this.timeoutId)

        EventBus.$emit('autoLogout:onInvalidSession')
    },

    start () {
        if (this.timeoutId) this.timeoutId = clearTimeout(this.timeoutId)

        const expirationTimestamp = this.getExpirationTimestampFromCookie()
        if (!expirationTimestamp) {
            this.onInvalidSession()
            return
        }

        const timeout = expirationTimestamp - Date.now() - this.warningPeriod
        this.timeoutId = setTimeout(this.onTimeout.bind(this), Math.max(timeout, 0))

        EventBus.$emit('autoLogout:startTimeout')
    },

    shouldShowWarning () {
        if (this.isServiceUnavailable()) return false

        const expirationTimestamp = this.getExpirationTimestampFromCookie()
        if (!expirationTimestamp) {
            this.onInvalidSession()
            return false
        }

        return expirationTimestamp - Date.now() <= this.warningPeriod
    },

    shouldHideWarning () {
        if (this.isServiceUnavailable()) return true

        const expirationTimestamp = this.getExpirationTimestampFromCookie()
        if (!expirationTimestamp) {
            this.onInvalidSession()
            return false
        }

        return expirationTimestamp - Date.now() >= this.warningPeriod
    },

    isExpired () {
        const expirationTimestamp = this.getExpirationTimestampFromCookie()
        if (!expirationTimestamp) {
            this.onInvalidSession()
            return false
        }

        return expirationTimestamp - Date.now() <= 0
    },

    onTimeout () {
        const expirationTimestamp = this.getExpirationTimestampFromCookie()
        if (!expirationTimestamp) {
            this.onInvalidSession()
            return
        }

        if (this.shouldShowWarning()) {
            EventBus.$emit('autoLogout:onTimeout', expirationTimestamp)
        } else {
            this.start()
        }
    },
}
